import app from '../../common/app';
import Component from '../../common/Component';
import ItemList from '../../common/utils/ItemList';
import listItems from '../../common/helpers/listItems';
import LinkButton from '../../common/components/LinkButton';
import Dropdown from '../../common/components/Dropdown';
import Button from '../../common/components/Button';


/**
 * The `PageHero` component displays the hero on a page page.
 *滚动发帖按钮
 * ### Props
 *
 * - `page`
 */
export default class ResponseItemsBtn extends Component {
  view(vnode) {
    return (
      <div className="sideNavContainer">
        <nav className="IndexPage-nav sideNav navItems dl-comment-btn">
          <ul>{listItems(this.navItems(vnode.attrs).toArray())}</ul>
        </nav>
      </div>
    );
  }

  navItems(attrs) {
    const items = new ItemList();
    // this.activeButton = localStorage.getItem('activeButton2') || 'allComments';
    const sortMap = ['top','latest','oldest','op','myReply'];

    let sortOptions = new Map();
    sortMap.map(element => {
      sortOptions.set(element, app.translator.trans(`dl-send.forum.resopnse_sort.${element}_button`));
    });

    // 优先使用外部传入的排序值，否则回退到全局搜索状态
    let sort = attrs.sort || app.search.params().sort;

    // 默认的排序变更函数：如果父组件没有提供 onChangeSort，则仍然使用全局 search 的 changeSort3（保持兼容）
    const changeSort = attrs.onChangeSort || app.search.changeSort3.bind(app.search);

    // if (sort == '-latest') {
    //   sort = 'latest';
    // } else if (sort == 'latest') {
    //   sort = 'oldest';
    // } else if (sort == '-top') {
    //   sort = 'top';
    // }
    
    
    items.add(
      'sort',
      <Dropdown
        buttonClassName="Button"
        label={sortOptions.get(sort) || sortOptions.get(sortMap[0])}
        accessibleToggleLabel={app.translator.trans('core.forum.index_sort.toggle_dropdown_accessible_label')}
      >
        {Array.from(sortOptions).map((value, key) => {
          let label = value[1][0];

          let active = (sort || sortMap[0]) === value[0];
          return (
            <Button icon={active ? 'fas fa-check' : true} onclick={() => changeSort(value[0])} active={active}>
              {label}
            </Button>
          );
        })}
      </Dropdown>
    );

    return items;
  }

  handleClick(item,attrs) {
    const navItems = document.querySelectorAll('.navItem');
  
  
    navItems.forEach((navItem) => {
      navItem.classList.remove('bold'); // 移除所有按钮的样式
      navItem.classList.remove('bold-underline');
    });
  
    const selectedNavItem = document.querySelector(`.${item}`);
    if (selectedNavItem) {
      selectedNavItem.classList.add('bold'); // 添加选中按钮的样式
      selectedNavItem.classList.add('bold-underline'); // 下划线
    }
    localStorage.setItem('activeButton2', item);
    if (item == 'allComments') {
      attrs.onDataFromChild(true);
    } else {
      attrs.onDataFromChild(false);
    }
  }
}
